import React from "react";
import { SharedDrive } from "~/gql/types2";
import {
  InlineTypeahead,
  InlineTypeaheadProps,
} from "~/components/inline-typeahead";

const format = (drive: SharedDrive): React.ReactNode =>
  `${drive.driveLetter}:\\ (best for access from the ${drive.physicalLocation} location)`;

type InlineFolderDrivePickerProps = {
  value: SharedDrive | null;
  name: string;
  onChange: (value: SharedDrive | null) => void;
  onBlur?: React.FocusEventHandler<any>;
  required?: boolean;
  submitError?: string;
  folderDrives: SharedDrive[];
};

export const InlineFolderDrivePicker: React.FC<InlineFolderDrivePickerProps> = (
  props
) => {
  const { folderDrives, ...rest } = props;

  const getData = async () => {
    return folderDrives;
  };

  const args = {
    ...rest,
    getData,
    format,
  } as InlineTypeaheadProps<SharedDrive>;

  return <InlineTypeahead {...args} />;
};
